export const JOURNEY_POSITION = {
  start: 'START',
  end: 'END',
};
